





































































import Vue from "vue";
import moment from "moment";

import { MODULE_COLORS } from "@/utility/Constants";

import { ApiResponseStatusEnum } from "@/model/communication/ApiResponseStatusEnum";

import { GetConfigurationHistoryEventsCommand, GetConfigurationHistoryEventsReqData } from "@/model/communication/caosConfiguration/GetConfigurationHistoryEventsCommand";
import { GetConfigurationHistoryEventsResData } from "@/model/communication/caosConfiguration/GetConfigurationHistoryEventsResData";
import { mapGetters } from "vuex";

export default Vue.extend({
    props: { showDialog: Boolean, installation: String },
    data() {
        return {
            moment,
            MODULE_COLORS,
            loadingConfigurationHistory: false,
            loadingShowMore: false,
            numOfEvents: 5,
            eventsBatch: 5,
            historyEvents: [],
            totalEvents: 0,
        };
    },
    watch: {
        installation: {
            handler() {
                if (this.installation) {
                    this.loadingConfigurationHistory = true;
                    this.sendRequestGetConfigurationHistory();
                }
            },
            immediate: true,
        },
    },
    computed: {
        ...mapGetters(["longDateFormat"]),
        showConfigurationHistoryDialog: {
            get() {
                return this.showDialog;
            },
            set(newValue: boolean) {
                this.$emit("update:showDialog", newValue);
                this.numOfEvents = this.eventsBatch;
            },
        },
    },
    methods: {
        async sendRequestGetConfigurationHistory() {
            let response: GetConfigurationHistoryEventsResData = await new GetConfigurationHistoryEventsCommand(
                new GetConfigurationHistoryEventsReqData(this.installation, this.numOfEvents)
            ).execute();

            if (response.responseStatus == ApiResponseStatusEnum.Success && response.responseString != "GenericError") {
                this.historyEvents = response.caosConfigurationHistory;
                this.totalEvents = response.totalEvents;
            }
            this.loadingConfigurationHistory = false;
            this.loadingShowMore = false;
        },
        showMore() {
            this.loadingShowMore = true;
            this.numOfEvents += this.eventsBatch;
            this.sendRequestGetConfigurationHistory();
        },
        getDotColor(events) {
            if (events.isBackup && events.resultCode == 50100) return "info";
            return events.resultCode == 50100 ? "success" : "error";
        },
        getDotIcon(events) {
            if (events.isBackup && events.resultCode == 50100) return "fas fa-save";
            return events.resultCode == 50100 ? "fas fa-check" : "fas fa-times";
        },
    },
});
